import { Theme } from '../types';

export interface AppConfig {
    appName: string;
    defaultTheme: Theme;
    version: string;
    isProduction: boolean;
    features: {
        enableWaitlist: boolean;
        enableGames: boolean;
        enablePredictions: boolean;
        enableShop: boolean;
        enableProps: boolean;
    };
}

// Check if we're in development mode
const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

export const appConfig: AppConfig = {
    appName: '2 Girls 1 Parlay',
    defaultTheme: 'dark',
    // Single source of truth: package.json, injected at build time.
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0',
    isProduction: !isDev,
    features: {
        enableWaitlist: true,
        // Always on in dev; in production set VITE_ENABLE_GAMES=true in Cloudflare Pages
        enableGames: isDev || import.meta.env.VITE_ENABLE_GAMES === 'true',
        // Always on in dev; in production set VITE_ENABLE_PREDICTIONS=true in Cloudflare Pages
        enablePredictions: isDev || import.meta.env.VITE_ENABLE_PREDICTIONS === 'true',
        // Always on in dev; in production set VITE_ENABLE_SHOP=true in Cloudflare Pages
        enableShop: isDev || import.meta.env.VITE_ENABLE_SHOP === 'true',
        // The Prop Desk. Always on in dev; in production set VITE_ENABLE_PROPS=true
        // in Cloudflare Pages once the Press Pass gate + backfill are ready to show.
        enableProps: isDev || import.meta.env.VITE_ENABLE_PROPS === 'true',
    },
};

// Environment variables - only include what's needed for landing page
export const env = {
    /**
     * API keys and sensitive data should be loaded from environment variables
     * Currently not needed for the landing page, but ready for future features
     */
    geminiApiKey: process.env.API_KEY || process.env.GEMINI_API_KEY,
    isDevelopment: process.env.NODE_ENV === 'development',
} as const;